import { useInfiniteQuery } from 'react-query';
import { accountService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useOrderHistory = (historyFilter: {
  selectedShipmentStatusFilters: string[];
}) => {
  const cacheKey = [];
  cacheKey.push(ServerStateKeysEnum.orderHistory);
  cacheKey.push(historyFilter.selectedShipmentStatusFilters);

  return useInfiniteQuery(
    cacheKey,
    ({ pageParam = 1 }) =>
      accountService.getDoctorOrderHistory({
        shipmentStatusFilters: historyFilter.selectedShipmentStatusFilters,
        pageParam: pageParam,
      }),
    {
      getNextPageParam: (lastPage, pages) => {
        if (typeof lastPage.currentPageNumber === 'undefined') {
          return undefined;
        }

        if (lastPage.currentPageNumber === lastPage.totalPages) {
          return undefined;
        } else {
          return lastPage.currentPageNumber + 1;
        }
      },
      staleTime: Infinity,
    }
  );
};
